/**
 * DIBAI 18K — Carrusel Fabricaciones v3.0.0 — Loop infinito
 */
(function () {
  'use strict';

  function init(root) {
    const track   = root.querySelector('[data-cpul-track]');
    const fill    = root.querySelector('[data-cpul-fill]');
    const prevBtn = root.querySelector('[data-cpul-prev]');
    const nextBtn = root.querySelector('[data-cpul-next]');

    if (!track) return;

    const origSlides = Array.from(track.children);
    const total      = origSlides.length;
    if (!total) return;

    function getCols() {
      const w = window.innerWidth;
      if (w <= 599) return parseInt(getComputedStyle(root).getPropertyValue('--cpul-cols-m').trim()) || 2;
      if (w <= 989) return 3;
      return parseInt(getComputedStyle(root).getPropertyValue('--cpul-cols').trim()) || 4;
    }

    function getGap() {
      return parseInt(getComputedStyle(root).getPropertyValue('--cpul-gap').trim()) || 6;
    }

    // Clonar slides al inicio y al final para el loop infinito
    function buildClones() {
      // Quitar clones previos
      track.querySelectorAll('[data-cpul-clone]').forEach(el => el.remove());

      const cols = getCols();

      // Clonar últimos `cols` slides al inicio
      for (let i = total - 1; i >= Math.max(0, total - cols); i--) {
        const clone = origSlides[i].cloneNode(true);
        clone.setAttribute('data-cpul-clone', 'start');
        clone.setAttribute('aria-hidden', 'true');
        track.insertBefore(clone, track.firstChild);
      }

      // Clonar primeros `cols` slides al final
      for (let i = 0; i < Math.min(cols, total); i++) {
        const clone = origSlides[i].cloneNode(true);
        clone.setAttribute('data-cpul-clone', 'end');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
    }

    let current    = 0; // índice real (0 = primer slide original)
    let isAnimating = false;
    let mouseStartX = 0;
    let mouseMoved  = false;
    let mouseActive = false;

    function allSlides() {
      return Array.from(track.children);
    }

    function slideW() {
      const s = allSlides()[0];
      if (!s) return 0;
      return s.getBoundingClientRect().width + getGap();
    }

    function clonesAtStart() {
      return track.querySelectorAll('[data-cpul-clone="start"]').length;
    }

    function setPosition(animated) {
      const offset = (clonesAtStart() + current) * slideW();
      track.style.transition = animated ? 'transform 0.4s cubic-bezier(0.4,0,0.2,1)' : 'none';
      track.style.transform  = `translateX(-${offset}px)`;

      // Barra de progreso
      if (fill) {
        const pct = total <= 1 ? 100 : ((current % total) / (total - 1)) * 100;
        fill.style.width = Math.max(8, pct) + '%';
      }
    }

    function go(delta) {
      if (isAnimating) return;
      isAnimating = true;
      current += delta;
      setPosition(true);
    }

    // Tras la transición, si estamos en un clon hacemos el jump invisible
    track.addEventListener('transitionend', () => {
      isAnimating = false;
      if (current < 0) {
        current = total - 1;
        setPosition(false);
      } else if (current >= total) {
        current = 0;
        setPosition(false);
      }
    });

    // Flechas
    prevBtn?.addEventListener('click', () => go(-1));
    nextBtn?.addEventListener('click', () => go(1));

    // Drag mouse
    track.addEventListener('mousedown', e => {
      if (e.target.closest('.cpul-slide__btn')) return;
      mouseStartX = e.clientX;
      mouseMoved  = false;
      mouseActive = true;
    });

    window.addEventListener('mousemove', e => {
      if (!mouseActive) return;
      const diff = e.clientX - mouseStartX;
      if (Math.abs(diff) > 5) {
        mouseMoved = true;
        track.style.transition = 'none';
        const offset = (clonesAtStart() + current) * slideW();
        track.style.transform  = `translateX(-${offset - diff}px)`;
      }
    });

    window.addEventListener('mouseup', e => {
      if (!mouseActive) return;
      mouseActive = false;
      if (!mouseMoved) return;
      const diff = e.clientX - mouseStartX;
      if (Math.abs(diff) > 60) go(diff < 0 ? 1 : -1);
      else setPosition(true);
    });

    track.addEventListener('click', e => {
      if (mouseMoved) { e.preventDefault(); e.stopPropagation(); mouseMoved = false; }
    }, true);

    // Touch swipe
    let touchStartX = 0;
    track.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', e => {
      const diff = e.touches[0].clientX - touchStartX;
      const offset = (clonesAtStart() + current) * slideW();
      track.style.transform = `translateX(-${offset - diff}px)`;
    }, { passive: true });

    track.addEventListener('touchend', e => {
      const diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 40) go(diff < 0 ? 1 : -1);
      else setPosition(true);
    }, { passive: true });

    // Autoplay
    let timer = setInterval(() => go(1), 3500);
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', () => { timer = setInterval(() => go(1), 3500); });

    // Resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        calcSlideWidth();
        buildClones();
        setPosition(false);
        initLightbox(root);
      }, 150);
    });

    function calcSlideWidth() {
      const cols    = getCols();
      const gap     = getGap();
      const total_w = root.querySelector('.cpul-carousel').offsetWidth;
      const w       = (total_w - gap * (cols - 1)) / cols;
      root.style.setProperty('--cpul-slide-w', w + 'px');
    }

    calcSlideWidth();
    buildClones();
    setPosition(false);
    initLightbox(root);
  }

  // ── Lightbox ──
  function initLightbox(root) {
    const lb      = root.querySelector('[data-cpul-lightbox]');
    const content = root.querySelector('[data-cpul-lb-content]');
    if (!lb) return;

    let slides = [];
    try {
      const dataEl = root.querySelector('[id^="cpul-data-"]');
      slides = JSON.parse(dataEl?.textContent || '[]');
    } catch(e) {}

    function open(idx) {
      const slide = slides[idx];
      if (!slide || !content) return;
      content.innerHTML = '';

      if (slide.type === 'video_file' || slide.type === 'video_url') {
        const video = document.createElement('video');
        video.className   = 'cpul-lb-video';
        video.controls    = true;
        video.autoplay    = true;
        video.playsinline = true;
        const source = document.createElement('source');
        source.src = slide.video;
        video.appendChild(source);
        content.appendChild(video);
      } else if (slide.image) {
        const img = document.createElement('img');
        img.className = 'cpul-lb-img';
        img.src = slide.image;
        img.alt = slide.label || 'Fabricación DIBAI';
        content.appendChild(img);
      }

      if (slide.label) {
        const lbl = document.createElement('p');
        lbl.className   = 'cpul-lb-label';
        lbl.textContent = slide.label;
        content.appendChild(lbl);
      }

      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
    }

    function close() {
      content?.querySelectorAll('video').forEach(v => { v.pause(); v.src = ''; });
      lb.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    // Re-bind (quitar listeners viejos clonando el nodo)
    lb.querySelectorAll('[data-cpul-lb-close]').forEach(el => {
      const fresh = el.cloneNode(true);
      el.replaceWith(fresh);
      fresh.addEventListener('click', close);
    });

    // Bind en slides originales únicamente (no clones)
    root.querySelectorAll('.cpul-slide:not([data-cpul-clone]) [data-cpul-open]').forEach(btn => {
      const fresh = btn.cloneNode(true);
      btn.replaceWith(fresh);
      fresh.addEventListener('click', () => {
        open(parseInt(fresh.dataset.cpulOpen, 10));
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.carrusel-pulsera-dibai-wrapper').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => {
    const root = e.target.querySelector('.carrusel-pulsera-dibai-wrapper') || e.target.closest('.carrusel-pulsera-dibai-wrapper');
    if (root) init(root);
  });
})();
